import { useEffect, useRef } from 'react';

const VideoPlayer = ({ stream, isLocal, videoRef }) => {
  const localRef = useRef(null);
  const ref = videoRef || localRef;

  useEffect(() => {
    if (stream && ref.current) {
      ref.current.srcObject = stream;
    }
  }, [stream,ref]);

  return (
    <video
      ref={ref}
      autoPlay
      playsInline
      muted={isLocal}
      className="w-full max-w-sm rounded shadow-md"
      style={{ transform: isLocal ? 'scaleX(-1)' : 'none' }}
    />
  );
};

export default VideoPlayer;



// import React, { useEffect, useRef, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import io from 'socket.io-client';

// const SOCKET_SERVER_URL = 'http://localhost:5000';

// function VideoCall() {
//   const { roomId } = useParams();
//   const localVideoRef = useRef(null);
//   const remoteVideoRef = useRef(null);
//   const peerConnectionRef = useRef(null);
//   const socketRef = useRef(null);
//   const localStreamRef = useRef(null);
//   const [callState, setCallState] = useState('initializing');
//   const [error, setError] = useState(null);
//   const [isCaller, setIsCaller] = useState(false);

//   useEffect(() => {
//     console.log('VideoCall mounted, room:', roomId);
//     if (!socketRef.current || !socketRef.current.connected) {
//       socketRef.current = io(SOCKET_SERVER_URL, {
//         reconnectionAttempts: 5,
//         forceNew: true,
//       });
//       console.log('Socket initialized');
//     }
//     const socket = socketRef.current;

//     navigator.mediaDevices
//       .getUserMedia({ video: { width: 640, height: 480 }, audio: true })
//       .then((stream) => {
//         console.log('Local stream acquired');
//         localStreamRef.current = stream;
//         if (localVideoRef.current) {
//           localVideoRef.current.srcObject = stream;
//         }
//         setCallState('waiting');
//       })
//       .catch((err) => {
//         console.error('Media access failed:', err);
//         setError('Camera/microphone access denied. Grant permissions and refresh.');
//         setCallState('ended');
//       });

//     if (socket) {
//       console.log('Attaching socket event listeners');
//       socket.on('connect', () => {
//         console.log('Socket connected, id:', socket.id);
//       });
//       socket.on('connect_error', (err) => {
//         console.error('Socket connect error:', err);
//         setError('Failed to connect to server');
//         setCallState('ended');
//       });
//       socket.on('ready', ({ roomId: receivedRoomId, isCaller: caller }) => {
//         console.log('Joined room:', receivedRoomId, 'isCaller:', caller);
//         setIsCaller(caller);
//         setCallState('waiting');
//       });
//       socket.on('peer-ready', (peerId) => {
//         console.log('Peer ready, peerId:', peerId);
//         if (localStreamRef.current && !peerConnectionRef.current) {
//           createPeerConnection();
//           if (isCaller) {
//             console.log('Caller initiating offer');
//             createOffer();
//           }
//         }
//         setCallState('connecting');
//       });
//       socket.on('offer', async (offer) => {
//         console.log('Received offer:', offer);
//         if (localStreamRef.current && !peerConnectionRef.current) {
//           createPeerConnection();
//         }
//         if (peerConnectionRef.current) {
//           await handleOffer(offer);
//         } else {
//           console.error('No peer connection to handle offer');
//         }
//         setCallState('connecting');
//       });
//       socket.on('answer', async (answer) => {
//         console.log('Received answer:', answer);
//         if (peerConnectionRef.current) {
//           try {
//             await peerConnectionRef.current.setRemoteDescription(new RTCSessionDescription(answer));
//             console.log('Answer set successfully');
//           } catch (err) {
//             console.error('Set answer failed:', err);
//             setError('Failed to process answer');
//           }
//         }
//       });
//       socket.on('ice-candidate', async (candidate) => {
//         console.log('Received ICE candidate:', candidate);
//         if (peerConnectionRef.current && candidate) {
//           try {
//             await peerConnectionRef.current.addIceCandidate(new RTCIceCandidate(candidate));
//             console.log('ICE candidate added successfully');
//           } catch (err) {
//             console.error('ICE add failed:', err);
//           }
//         }
//       });
//       socket.on('call-ended', () => {
//         console.log('Peer ended call');
//         setError('Call ended by peer');
//         endCall();
//       });
//       socket.on('room-full', () => {
//         console.log('Room full');
//         setError('Room is full');
//         setCallState('ended');
//       });
//       socket.on('disconnect', () => {
//         console.log('Socket disconnected');
//         if (callState === 'active') {
//           setError('Connection lost');
//           endCall();
//         }
//       });
//       socket.emit('join-room', roomId);
//     } else {
//       console.error('Socket not initialized');
//       setError('Socket initialization failed');
//       setCallState('ended');
//     }

//     return () => {
//       console.log('VideoCall cleanup, callState:', callState);
//       if (callState === 'active' || callState === 'connecting') {
//         endCall();
//       } else {
//         cleanupResources();
//         if (socketRef.current) {
//           socketRef.current.emit('end-call', roomId);
//           socketRef.current.disconnect();
//           socketRef.current = null;
//         }
//       }
//     };
//   }, [roomId]);

//   const createPeerConnection = () => {
//     const config = {
//       iceServers: [
//         { urls: 'stun:stun.l.google.com:19302' },
//         { urls: 'stun:stun1.l.google.com:19302' },
//         { urls: 'stun:stun2.l.google.com:19302' },
//       ]
//     };
//     peerConnectionRef.current = new RTCPeerConnection(config);
//     console.log('PeerConnection created');

//     localStreamRef.current.getTracks().forEach((track) => {
//       peerConnectionRef.current.addTrack(track, localStreamRef.current);
//     });

//     peerConnectionRef.current.ontrack = (event) => {
//       console.log('ontrack event:', event);
//       console.log('Remote stream:', event.streams[0]);
//       if (remoteVideoRef.current) {
//         remoteVideoRef.current.srcObject = event.streams[0];
//         console.log('Remote stream assigned to video element');
//       } else {
//         console.error('remoteVideoRef is not available');
//       }
//       setCallState('active');
//     };

//     peerConnectionRef.current.onicecandidate = (event) => {
//       if (event.candidate) {
//         console.log('Sending ICE candidate:', event.candidate);
//         socketRef.current.emit('ice-candidate', { candidate: event.candidate, roomId });
//       } else {
//         console.log('No more ICE candidates');
//       }
//     };

//     peerConnectionRef.current.onsignalingstatechange = () => {
//       console.log('Signaling state:', peerConnectionRef.current.signalingState);
//     };

//     peerConnectionRef.current.oniceconnectionstatechange = () => {
//       const state = peerConnectionRef.current.iceConnectionState;
//       console.log('ICE connection state:', state);
//       if (state === 'failed') {
//         console.error('ICE connection failed');
//         setError('Connection failed - try a different browser or device, or add a TURN server');
//         endCall();
//       } else if (state === 'connected' || state === 'completed') {
//         console.log('ICE connection established');
//         setCallState('active');
//       } else if (state === 'disconnected') {
//         console.error('ICE connection disconnected');
//         setError('Connection lost');
//         endCall();
//       }
//     };
//   };

//   const createOffer = async () => {
//     if (!peerConnectionRef.current) {
//       console.error('No peer connection available');
//       return;
//     }
//     try {
//       console.log('Starting createOffer');
//       const offer = await peerConnectionRef.current.createOffer();
//       console.log('Offer created:', offer);
//       await peerConnectionRef.current.setLocalDescription(offer);
//       console.log('Local description set:', offer);
//       socketRef.current.emit('offer', { offer, roomId });
//       console.log('Offer sent to room:', roomId);
//     } catch (err) {
//       console.error('Offer failed:', err);
//       setError('Failed to create offer');
//     }
//   };

//   const handleOffer = async (offer) => {
//     if (!peerConnectionRef.current) {
//       console.error('No peer connection to handle offer');
//       return;
//     }
//     try {
//       console.log('Handling offer:', offer);
//       await peerConnectionRef.current.setRemoteDescription(new RTCSessionDescription(offer));
//       const answer = await peerConnectionRef.current.createAnswer();
//       console.log('Answer created:', answer);
//       await peerConnectionRef.current.setLocalDescription(answer);
//       console.log('Answer set locally');
//       socketRef.current.emit('answer', { answer, roomId });
//       console.log('Answer sent to room:', roomId);
//     } catch (err) {
//       console.error('Handle offer failed:', err);
//       setError('Failed to respond to offer');
//     }
//   };

//   const endCall = () => {
//     console.log('Ending call');
//     setCallState('ended');
//     if (peerConnectionRef.current) {
//       peerConnectionRef.current.close();
//       peerConnectionRef.current = null;
//     }
//     cleanupResources();
//     if (socketRef.current) {
//       socketRef.current.emit('end-call', roomId);
//       socketRef.current.disconnect();
//       socketRef.current = null;
//     }
//     localStorage.removeItem('roomId');
//     window.location.href = '/';
//   };

//   const cleanupResources = () => {
//     console.log('Cleaning resources');
//     if (localStreamRef.current) {
//       localStreamRef.current.getTracks().forEach((track) => track.stop());
//       localStreamRef.current = null;
//     }
//     if (localVideoRef.current) localVideoRef.current.srcObject = null;
//     if (remoteVideoRef.current) remoteVideoRef.current.srcObject = null;
//   };

//   const getStatusMessage = () => {
//     switch (callState) {
//       case 'initializing': return 'Initializing...';
//       case 'waiting': return isCaller ? 'Share URL with peer to start call' : 'Waiting for peer...';
//       case 'connecting': return 'Connecting...';
//       case 'active': return 'Call active';
//       default: return 'Call ended';
//     }
//   };

//   if (error) {
//     return (
//       <div style={{ textAlign: 'center', padding: '20px', color: 'red' }}>
//         <h2>Error: {error}</h2>
//         <button onClick={() => { localStorage.removeItem('roomId'); window.location.href = '/'; }}>
//           Back to Home
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
//       <h2>Room: {roomId}</h2>
//       <p>{getStatusMessage()}</p>
//       {isCaller && callState === 'waiting' && (
//         <p>Share: {window.location.origin}/call/{roomId}</p>
//       )}
//       <div style={{ display: 'flex' }}>
//         <video
//           ref={localVideoRef}
//           autoPlay
//           muted
//           playsInline
//           style={{ width: '300px', height: '240px', margin: '10px', background: 'black', border: '1px solid gray' }}
//         />
//         <video
//           ref={remoteVideoRef}
//           autoPlay
//           playsInline
//           style={{ width: '300px', height: '240px', margin: '10px', background: 'black', border: '1px solid gray' }}
//         />
//       </div>
//       {callState === 'active' && (
//         <button onClick={endCall} style={{ padding: '10px' }}>End Call</button>
//       )}
//     </div>
//   );
// }

// export default VideoCall;